export enum WifiStates {
  noService = 0,
  ssidNotExisting = 1,
  changeError = 3
}
